module.exports = __webpack_public_path__ + "732389ded34cb9c52dd88271f1345af9.ttf";